import { mpUtils } from '@tujia/fe-lib-bridge'
import { Sniff } from './q_sniff'
import { getMpLinkWithCode } from '@/utils/linkUtil'

export default {
  methods: {
    async redirectTo(links) {
      const { mpLink, appLink, activeLink: webLink } = links
      const { isWxMpEnv, isQunarAppEnv } = this.platformEnv
      const { code = `cms_${this.$root.promotionId}` } = this.$route.query
      if (isWxMpEnv && (mpLink || webLink)) {
        mpUtils.navigateTo({
          url: getMpLinkWithCode(mpLink, webLink, code)
        })
      } else if (appLink && isQunarAppEnv && (!Sniff.isHarmonyWithoutAdr || Sniff.isHarmonySupportRN)) {
        let rnUrl = Sniff.scheme + '://' + appLink
        // 补上channelId
        // react/open?hybridId=bnbrn&pageName=SearchList&initProps=%7B%22param%22%3A%7B%22id%22%3A48%2C%22url%22%3A%22https%3A%2F%2Fm.tujia.com%2Fgongyu%2Fbeijing%2F%3FcityId%3D48%26cds%3D6_4168__5_12_10609%22%7D%7D
        try {
          const rnParams = rnUrl.split('initProps=')
          if (rnParams && rnParams[1]) {
            let rnProps = JSON.parse(decodeURIComponent(rnParams[1]))
            if (rnProps.channelId === undefined) {
              rnProps.channelId = this.$route.query.code || `cms_${this.$root.promotionId}`
            }
            rnProps = JSON.stringify(rnProps)
            rnUrl = `${rnParams[0]}initProps=${encodeURIComponent(rnProps)}`
          }
        } catch (e) {
        }
        window.location.href = rnUrl
      } else if (webLink) {
        const isTWebUrl = webLink.indexOf('tujia.com') > -1
        const isMobUrl = webLink.indexOf('m.tujia.com') > -1
        const h5Url = webLink.indexOf('code') > -1 ? webLink : webLink + `${webLink.indexOf('?') > -1 ? '&code' : '?code=' + code}`
        window.location.href = isTWebUrl ? `https://bnb.qunar.com/tjbnb/app/index.jsp?#/passport?targetType=${isMobUrl ? 'tujiamob' : 'tujiapwa'}&forceLogin=1&redirect=${encodeURIComponent(h5Url)}` : h5Url
      }
    }
  }
}
